// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as BlacklistPartnerForm from "./partner-blacklist/BlacklistPartnerForm.bs.js";
import * as TrustAndSafetySidebar from "./TrustAndSafetySidebar.bs.js";
import * as BlacklistPartnerDataMachine from "../../app/partner-blacklist/data-machine/BlacklistPartnerDataMachine.bs.js";
import * as TrustAndSafetyAssetsManager from "../assets/TrustAndSafetyAssetsManager.bs.js";

TrustAndSafetyAssetsManager.importCss(undefined);

var layersIcon = TrustAndSafetyAssetsManager.getImage("layers-icon.svg");

function defaultBlacklistTypes(param) {
  return [
          /* Documents */0,
          /* Device */1,
          /* Face */2
        ];
}

function TrustAndSafetyContainer(Props) {
  var initialFeature = Props.initialFeature;
  var prefill = Props.prefill;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return /* Blacklist */0;
      });
  var setActionType = match$1[1];
  var actionType = match$1[0];
  var match$2 = React.useState(function () {
        return Belt_Option.getWithDefault(prefill.msisdn, "");
      });
  var setMsisdn = match$2[1];
  var msisdn = match$2[0];
  var match$3 = React.useState(function () {
        
      });
  var setFraudType = match$3[1];
  var fraudType = match$3[0];
  var match$4 = React.useState(function () {
        return [
                /* Documents */0,
                /* Device */1,
                /* Face */2
              ];
      });
  var setBlacklistTypes = match$4[1];
  var blacklistTypes = match$4[0];
  var match$5 = React.useState(function () {
        return "";
      });
  var setComment = match$5[1];
  var comment = match$5[0];
  var match$6 = React.useState(function () {
        return /* Idle */0;
      });
  var setStatus = match$6[1];
  var status = match$6[0];
  var match$7 = React.useState(function () {
        return /* NoResult */0;
      });
  var setResult = match$7[1];
  var isSubmitting = typeof status === "number" ? status !== 0 : false;
  var onSuccess = function (response) {
    Curry._1(setResult, (function (param) {
            return {
                    TAG: /* Success */0,
                    _0: response.message
                  };
          }));
    Curry._1(setMsisdn, (function (param) {
            return "";
          }));
    Curry._1(setFraudType, (function (param) {
            
          }));
    Curry._1(setBlacklistTypes, (function (param) {
            return [
                    /* Documents */0,
                    /* Device */1,
                    /* Face */2
                  ];
          }));
    Curry._1(setComment, (function (param) {
            return "";
          }));
    return Curry._1(setStatus, (function (param) {
                  return /* Idle */0;
                }));
  };
  var onFailure = function (error) {
    var errorMessage = ErrorUtils$Catalyst.resolveError(error);
    var displayMessage = errorMessage.trim().length !== 0 ? errorMessage : "Something went wrong. Please try again.";
    Curry._1(setResult, (function (param) {
            return {
                    TAG: /* Error */1,
                    _0: displayMessage
                  };
          }));
    return Curry._1(setStatus, (function (param) {
                  return /* Idle */0;
                }));
  };
  var handleSubmit = function ($$event) {
    $$event.preventDefault();
    if (blacklistTypes.length === 0) {
      return Curry._1(setResult, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: "Please select at least one blacklist type"
                          };
                  }));
    }
    Curry._1(setStatus, (function (param) {
            return /* Submitting */1;
          }));
    var trimmedComment = comment.trim();
    var trimmedMsisdn = msisdn.trim();
    if (actionType) {
      var payload = {
        msisdn: trimmedMsisdn,
        whitelistTypes: blacklistTypes,
        comment: trimmedComment
      };
      return BlacklistPartnerDataMachine.whitelistPartner(payload, onSuccess, onFailure, country);
    }
    if (fraudType === undefined) {
      return Curry._1(setStatus, (function (param) {
                    return /* Idle */0;
                  }));
    }
    var payload$1 = {
      msisdn: trimmedMsisdn,
      fraudType: fraudType,
      blacklistTypes: blacklistTypes,
      comment: trimmedComment
    };
    return BlacklistPartnerDataMachine.blacklistPartner(payload$1, onSuccess, onFailure, country);
  };
  var tmp;
  switch (initialFeature) {
    case /* BulkSuspensions */0 :
        tmp = React.createElement("div", {
              className: "c-blacklist-partner-page__placeholder"
            }, React.createElement("h2", undefined, "Bulk Suspensions"), React.createElement("p", undefined, "Coming soon..."));
        break;
    case /* PartnerBlacklist */1 :
        tmp = React.createElement(BlacklistPartnerForm.make, {
              actionType: actionType,
              msisdn: msisdn,
              fraudType: fraudType,
              blacklistTypes: blacklistTypes,
              comment: comment,
              result: match$7[0],
              onActionTypeChange: (function (value) {
                  Curry._1(setResult, (function (param) {
                          return /* NoResult */0;
                        }));
                  return Curry._1(setActionType, (function (param) {
                                return value;
                              }));
                }),
              onMsisdnChange: (function (value) {
                  Curry._1(setResult, (function (param) {
                          return /* NoResult */0;
                        }));
                  return Curry._1(setMsisdn, (function (param) {
                                return value;
                              }));
                }),
              onFraudTypeChange: (function (value) {
                  Curry._1(setResult, (function (param) {
                          return /* NoResult */0;
                        }));
                  return Curry._1(setFraudType, (function (param) {
                                return value;
                              }));
                }),
              onBlacklistTypeToggle: (function (bt) {
                  Curry._1(setResult, (function (param) {
                          return /* NoResult */0;
                        }));
                  return Curry._1(setBlacklistTypes, (function (prev) {
                                if (Belt_Array.some(prev, (function (t) {
                                          return t === bt;
                                        }))) {
                                  return Belt_Array.keep(prev, (function (t) {
                                                return t !== bt;
                                              }));
                                } else {
                                  return Belt_Array.concat(prev, [bt]);
                                }
                              }));
                }),
              onCommentChange: (function (value) {
                  Curry._1(setResult, (function (param) {
                          return /* NoResult */0;
                        }));
                  return Curry._1(setComment, (function (param) {
                                return value;
                              }));
                }),
              onSubmit: handleSubmit,
              isSubmitting: isSubmitting
            });
        break;
    case /* WalletWithdrawalBlock */2 :
        tmp = React.createElement("div", {
              className: "c-blacklist-partner-page__placeholder"
            }, React.createElement("h2", undefined, "Wallet Withdrawal Block/Unblock"), React.createElement("p", undefined, "Coming soon..."));
        break;
    
  }
  return React.createElement("div", {
              className: "c-blacklist-partner-page"
            }, React.createElement("div", {
                  className: "c-blacklist-partner-page__header"
                }, React.createElement("div", {
                      className: "c-blacklist-partner-page__header-title"
                    }, React.createElement("img", {
                          alt: "",
                          src: layersIcon
                        }), React.createElement("span", undefined, "Trust & Safety / Manual Actions")), React.createElement("div", {
                      className: "c-blacklist-partner-page__badge"
                    }, "INTERNAL TOOL")), React.createElement("div", {
                  className: "c-blacklist-partner-page__container"
                }, React.createElement(TrustAndSafetySidebar.make, {
                      activeFeature: initialFeature
                    }), React.createElement("div", {
                      className: "c-blacklist-partner-page__content"
                    }, tmp)));
}

var make = TrustAndSafetyContainer;

export {
  layersIcon ,
  defaultBlacklistTypes ,
  make ,
  
}
/*  Not a pure module */
